module.exports = __webpack_public_path__ + "static/media/Company-Management.09724e08.svg";